import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { BreadcrumbComponent, SidenavComponent } from "@ubisolutions/base/components";
import { NavigationMenuComponent, SidebarComponent } from "@ubisolutions/core";
import { APP_NAVIGATION } from "@pages/app.navigation";
import { ADMIN_NAVIGATION } from "./administration-sidebar-definition";
import {
    LanguageSelectorComponent,
} from "@shared/base/components/navigation/language-selector/language-selector.component";
import { AlertsMenuComponent } from "@shared/base/components/alerts/alerts/alerts-menu.component";
import { TopbarUserButtonComponent } from "@shared/base/components/topbar-user-button/topbar-user-button.component";

@Component({
    selector: "app-admin-home",
    imports: [
        SidebarComponent,
        RouterOutlet,
        SidenavComponent,
        BreadcrumbComponent,
        NavigationMenuComponent,
        LanguageSelectorComponent,
        AlertsMenuComponent,
        TopbarUserButtonComponent,
    ],
    templateUrl: "./administration-home.component.html",
    styleUrl: "./administration-home.component.scss",
})
export class AdministrationUbiHomeComponent {
    protected readonly navigationData = ADMIN_NAVIGATION;
    protected readonly APP_NAVIGATION = APP_NAVIGATION;
}
